module.exports = __webpack_public_path__ + "media/images/frontend/grid_view-ec5689f22cb36b5c5f2212db1de2dd47.svg";